export var Name = 'newsletter-subscribe';
export var NewsletterSubscribe = Name;